import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@css/common.css";
import "@css/utility.css";
import "@script/group_sync";
import { ReactQueryClientProvider } from "@components/ReactQueryClientProvider";
import { Toaster as SonnerToaster } from "sonner";
import App from "./App.tsx";
import { StrictMode } from "react";
// 한번만 렌더 되도록 여기에 추가
import "./utils/sortablePlugins";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <ReactQueryClientProvider>
        <BrowserRouter>
          {/* Toast */}
          <SonnerToaster position="top-center" />
          <App />
        </BrowserRouter>
      </ReactQueryClientProvider>
    </HelmetProvider>
  </StrictMode>
);
